import { computed } from 'vue';
import useExperimentIds from '@composables/useExperimentIds';

const DYNAMIC_FILTERS_EXP_ID = '2635-21';

export default function useDynamicFilters() {
  const { experimentIds } = useExperimentIds();

  const isDynamicFilters = computed(() => experimentIds.value.includes(DYNAMIC_FILTERS_EXP_ID));

  return {
    isDynamicFilters,
  };
}
